import { gql } from '@apollo/client';
import surveyQueryFragment from './surveyQueryFragment';

const GET_SURVEY_RESULTS = gql`
  query getSurveyResults {
    getSurveyResults {
      ...SurveyFields
    }
  }
  ${surveyQueryFragment}
`;

export default GET_SURVEY_RESULTS;
